import React, { FC } from "react";
import { AboutUsSection } from "src/page-components/home/about-us/AboutUsSection";
import { AdvantagesSection } from "src/page-components/home/advantages/AdvantagesSection";
import { BannerSection } from "src/page-components/home/Banner/BannerSection";
import { ServicePackagesSection } from "src/page-components/home/service-packages/ServicePackagesSection";
import { ServicesSection } from "src/page-components/home/services/ServicesSection";
import { Stackable } from "src/page-components/home/Stackable";
import { TeamSection } from "src/page-components/home/team/TeamSection";
import { PageWrapper } from "src/components/Layouts/PageWrapper";
import { HashObserver } from "src/page-components/home/HashObserver";
import { SECTION_IDS_ARRAY } from "src/page-components/home/constants";
import { ContactUsSection } from "src/page-components/home/contact-us/ContactUsSection";
import { ContactUsScrollButton } from "src/page-components/home/ContactUsScrollButton";
import { SEO } from "src/components/SEO/SEO";
import { PATHNAMES } from "src/constants/routes";

const Home: FC = () => (
  <>
    <SEO
      title="Головна"
      description="Професійні послуги з бухгалтерського обліку, оподаткування та юридичного супроводу для бізнесу в Україні. Комплексний підхід до ведення бізнесу."
      keywords="бухгалтерський облік, оподаткування, юридичний супровід, ФОП, юридична особа, бухгалтерські послуги, Україна"
      url={PATHNAMES.HOME}
    />
    <PageWrapper mainClassName="flex flex-col gap-12 px-2.5 pb-2.5 bg-gray-light md:px-6 lg:pb-0 xl:gap-0">
    <HashObserver sections={SECTION_IDS_ARRAY}>
      <BannerSection />
      <Stackable>
        <AboutUsSection />
      </Stackable>

      <Stackable>
        <AdvantagesSection />
      </Stackable>

      <Stackable>
        <ServicePackagesSection />
      </Stackable>

      <Stackable>
        <ServicesSection />
      </Stackable>

      <Stackable>
        <TeamSection />
      </Stackable>

      <Stackable>
        <ContactUsSection />
      </Stackable>

      <ContactUsScrollButton />
    </HashObserver>
  </PageWrapper>
  </>
);
export default Home;
